import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'watchlist-search-results',
  templateUrl: 'watchlist-search-results.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WatchlistSearchResultsComponent {
  @Input() fuzzyResults: any;
  @Output() addToWatchlist: EventEmitter<any> = new EventEmitter();

  constructor() {
  }
  trackByFn(index, item) {
    return item._id;
  }
  _addToWatchlist(item) {
    this.addToWatchlist.emit(item);
  }
}



// WEBPACK FOOTER //
// ./src/components/watchlist-search-results/watchlist-search-results.ts